import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { Modal } from '@gousto-internal/citrus-react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { RecipeCoreId, RecipeUUID } from '@library/menu-service'

import { DetailContent } from 'routes/Menu/MenuExperience/Detail/DetailContent'

import css from './Detail.css'

type DetailProps = {
  uuid: RecipeUUID
  coreId: RecipeCoreId
  title: string
  showOverlay: boolean
  error: boolean
  loading: boolean
  recipe: RecipeQueryResponse | null
  position?: string
  reload: () => void
  onClose: () => void
}

const getAllergenCount = (recipe: RecipeQueryResponse | null) => recipe?.allergens?.list.length ?? 0

export const Detail = ({
  uuid,
  coreId,
  title,
  showOverlay,
  error,
  loading,
  recipe,
  reload,
  onClose,
  position,
}: DetailProps) => (
  <Modal
    name="recipe-detail-modal"
    isOpen={showOverlay}
    onAfterOpen={() => {
      datadogRum.addAction('view_menu_recipe_detail', {
        recipe_id: recipe?.id,
        position,
        allergen_count: getAllergenCount(recipe),
      })
    }}
    onRequestClose={onClose}
    overlayClassName={css.overlay}
  >
    <DetailContent
      uuid={uuid}
      coreId={coreId}
      title={title}
      error={error}
      loading={loading}
      recipe={recipe}
      reload={reload}
      onClose={onClose}
      position={position}
    />
  </Modal>
)
